import * as React from 'react';
import { css } from '@emotion/core';


const rootStyle = css`
  flex-shrink: 0;
  flex-grow: 0;
`;


interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  sizePx?: number;
}


/**
 * Spacer: a component that renders as empty space. Sets width/height to the same value, so your localized divs can lay
 * out correct in both LTR/RTL
 *
 * PureComponent: true
 * Redux Connected: false
 */
const Spacer: React.FC<Props> = props => {
  const { sizePx, ...rest } = props;
  return (
    <div
      css={[
        rootStyle,
        css`flex-basis: ${sizePx}px; width: ${sizePx}px; height: ${sizePx}px;`,
      ]}
      {...rest}
    />
  );
};

Spacer.defaultProps = {
  sizePx: 20,
};

export default Spacer;
